import React, { useEffect, useRef } from 'react'
import flatpickr from 'flatpickr'
import { French } from 'flatpickr/dist/l10n/fr'

const DateRangePicker = ({ initialStartDate, initialEndDate, onChange }) => {
  const inputRef = useRef(null)

  useEffect(() => {
    const input = inputRef.current
    if (!input)
      return null

    const defaultDates = []
    if (initialStartDate)
      defaultDates.push(new Date(initialStartDate))
    if (initialEndDate)
      defaultDates.push(new Date(initialEndDate))

    const fp = flatpickr(input, {
      dateFormat: 'd/m/Y',
      allowInput: true,
      mode: 'range',
      locale: French,
      defaultDate: defaultDates.length > 0 ? defaultDates : null,
      onChange: dates => {
        if (dates.length === 2)
          onChange(dates[0], dates[1])
      }
    })

    // Restore type="search" after flatpickr initialization (flatpickr changes it to "text")
    input.type = 'search'

    // Handle native search input clear (X button)
    const handleSearch = () => {
      if (input.value === '') {
        fp.clear()
        onChange(null, null)
      }
    }
    input.addEventListener('search', handleSearch)

    return () => {
      input.removeEventListener('search', handleSearch)
      fp.destroy()
    }
  }, [initialStartDate, initialEndDate, onChange])

  return (
    <div className="col-6 col-md mb-2">
      <label htmlFor="date_range">Période</label>
      <input
        className="form-control"
        id="date_range"
        name="date_range"
        placeholder="Choisir..."
        ref={inputRef}
        type="search"
      />
    </div>
  )
}

export default DateRangePicker
